import { cn } from '@/lib/cn';

export type ButtonVariant =
  | 'primary-purple'
  | 'primary-yellow'
  | 'ghost-purple'
  | 'whatsapp';

export type ButtonSize = 'sm' | 'md' | 'lg';

export const buttonBase =
  'inline-flex items-center justify-center gap-2 rounded-full font-medium ' +
  'transition-all duration-200 select-none ' +
  'disabled:cursor-not-allowed disabled:opacity-50 ' +
  'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-yellow';

export const buttonVariants: Record<ButtonVariant, string> = {
  'primary-purple':
    'bg-brand-purple text-white hover:bg-brand-purple/90 active:bg-brand-purple/80',
  'primary-yellow':
    'bg-brand-yellow text-brand-purple hover:bg-brand-yellow/90 active:bg-brand-yellow/80',
  'ghost-purple':
    'bg-transparent text-brand-purple border border-brand-purple/20 ' +
    'hover:bg-brand-purple/5 hover:border-brand-purple/40',
  whatsapp:
    'bg-brand-yellow text-brand-purple hover:bg-brand-yellow/90 ' +
    'shadow-sm hover:shadow',
};

export const buttonSizes: Record<ButtonSize, string> = {
  sm: 'text-xs px-4 py-2',
  md: 'text-sm px-5 py-2.5',
  lg: 'text-base px-7 py-3.5',
};

/**
 * Return the Button's composed className — useful when rendering the same
 * visual as an <a href> or <Link to>, e.g.
 *
 *   <Link to="/contato" className={buttonClasses('primary-yellow', 'lg')}>
 *     Fale conosco
 *   </Link>
 */
export function buttonClasses(
  variant: ButtonVariant = 'primary-purple',
  size: ButtonSize = 'md',
  extra?: string
): string {
  return cn(buttonBase, buttonVariants[variant], buttonSizes[size], extra);
}
